/**
 * UI component for App.
 * This file owns the screen or feature-level presentation flow for its route or
 * embedded module context.
 */
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiLoaderOutletComponent, UiToastOutletComponent } from '@shared/ui';

/**
 * COMPONENT: App
 * Inputs: Uses the parameters, injected services, route state, or signal state declared by this file.
 * Output: Returns the documented value or updates component/service state without changing the public contract.
 * Processing: Documents the Angular declaration that connects this class to templates, dependency injection, or template transforms.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, UiToastOutletComponent, UiLoaderOutletComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {}
